import { format, isValid } from 'date-fns';
import stringToDate from './stringToDate';

const stringToMonthYear = (str: string) => {
  const date = stringToDate(str);

  return date && isValid(date) ? format(date, 'MMM yyyy') : 'Invalid Date';
};

export default stringToMonthYear;
